import axios from "axios";
import { PackageClientHistoryProcessor } from "../../utils/PackageClientHistoryProcessor";
import PackageHandler from "../../utils/PackageHandler";

export const URL_PackageProcedure = (`${process.env.REACT_APP_HOST}/packageprocedure`);
export const URL_PackageClientHistory = (`${process.env.REACT_APP_HOST}/packageclienthistory`);
export const URL_PackageServiceSchedulingProvided = (`${process.env.REACT_APP_HOST}/PackageServicesSchedulingProvided`)
export const URL_SellPackageProcedure = (`${process.env.REACT_APP_HOST}/packageprocedure/registersell`);
export const URL_PackageNotifications = (`${process.env.REACT_APP_HOST}/packageNotifications`);

export async function getPackagesBalanceByIdClient(idClient) {
    let pchH = new PackageHandler();
    let data = await pchH.getAvailableProceduresByIdClient(idClient);
    return data;
}